// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CxE6","type":"styles_type__1e8YM","choices":"styles_choices__3mznr"};